// Pure formatters for the read-mode document meta line.
// No DOM, no React, no fetch — unit-tested in doc-meta.test.js.
// Attached to window.mindexDocMeta by vendor.entry.js.
import { formatBytes } from './trash-groups.js';

const MIN = 60_000;
const HR = 60 * MIN;
const DAY = 24 * HR;
const WEEK = 7 * DAY;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Relative for ALL ages — never returns a raw ISO date (B2 fix).
export function formatEditedAgo(mtimeMs, nowMs) {
  if (mtimeMs == null) return '';
  const delta = Math.max(0, nowMs - mtimeMs);
  if (delta < MIN) return 'just now';
  if (delta < HR) return `${Math.floor(delta / MIN)}m ago`;
  if (delta < DAY) return `${Math.floor(delta / HR)}h ago`;
  if (delta < WEEK) return `${Math.floor(delta / DAY)}d ago`;
  const d = new Date(mtimeMs);
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
}

// Builds e.g. "23 lines · 1.4 KB · edited 2m ago" with a real middot (B1).
export function formatMetaLine({ lines, size, mtime } = {}, nowMs) {
  const parts = [];
  if (lines != null) parts.push(`${lines} lines`);
  if (size != null) parts.push(formatBytes(size));
  if (mtime != null) parts.push(`edited ${formatEditedAgo(mtime, nowMs)}`);
  return parts.join(' · ');
}
